import React, { useState } from 'react'
import { useNavigate, Outlet } from 'react-router-dom'
import { useSidebar } from '../hooks/layout'
import { Sidebar } from './layout/Sidebar'
import { Header } from './layout/Header'
import { useSessionValidation } from '../hooks/auth/useSessionValidation'
import { useAuth } from '../contexts/AuthContext'

interface DashboardProps {
  onLogout: () => void
}

/**
 * Componente principal del Dashboard
 * Orquestador que compone Sidebar, Header y contenido principal
 */
const Dashboard: React.FC<DashboardProps> = ({ onLogout }) => {
  const navigate = useNavigate()
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const { isCollapsed, toggle: toggleSidebar } = useSidebar()
  const { logout } = useAuth()

  // Validar sesión periódicamente (no al montar para evitar redirecciones innecesarias)
  useSessionValidation({
    validationInterval: 5 * 60 * 1000, // 5 minutos
    validateOnMount: false, // No validar al montar para evitar redirecciones al refrescar
    validateOnVisibilityChange: true,
    onSessionExpired: () => {
      logout()
      onLogout()
      navigate('/login', { replace: true })
    },
  })

  const handleLogout = () => {
    logout()
    onLogout()
    navigate('/login', { replace: true })
  }

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
        isCollapsed={isCollapsed}
        onToggleCollapse={toggleSidebar}
      />
      <div className="flex-1 flex flex-col">
        <Header
          onLogout={handleLogout}
          onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}
        />
        <main className="flex-1 overflow-y-auto transition-all duration-300">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default Dashboard
